import './index.css'

const HomeSection = () => (
  <div className="home-content">
    <h1 className="name">K S S Prathyush</h1>
    <p className="dev-role">Frontend Web Developer</p>
    <p className="experiences">
      Experienced in HTML, CSS, Vanilla JS, Bootstrap, React JS, Figma
    </p>
    <button className="resume-btn">View Resume</button>
  </div>
)

export default HomeSection
